import React from "react";
import { Routes, Route } from "react-router-dom";
import AddEmployee from "../../Employee/Pages/AddEmployee";
import AddConsultant from "../../Consultant/Pages/AddConsultant";
import MasterDataTable from "../../MasterData/Pages/MasterDataTable";
import MasterData from "../../MasterData/Pages/MasterData";
import AdminDashboard from "../../AdminDashboard/Pages/AdminDashboard";
import AdminPrivateRoute from "./AdminPrivateRoutes";
// import ReportIssue from "../../ReportIssue/Pages/ReportIssue";

const AdminRoutes = () => {
  return (
    <Routes>
        <Route path="Dashboard" element={<AdminPrivateRoute><AdminDashboard /> </AdminPrivateRoute>} />
        <Route path="Add-Employee" element={<AdminPrivateRoute><AddEmployee /> </AdminPrivateRoute>} />
        <Route path="Add-Consultant" element={<AdminPrivateRoute><AddConsultant /> </AdminPrivateRoute>} />
        <Route path="Master-Data" element={<AdminPrivateRoute><MasterData /></AdminPrivateRoute>} />
        <Route path="Master-Data/:type" element={<AdminPrivateRoute><MasterDataTable /></AdminPrivateRoute>} />
         {/* <Route path="Report-Issue" element={<ReportIssue />} /> */}
    </Routes>
  );
};

export default AdminRoutes;
